import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';
import { of, Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PatientsService } from '../../core/services/patient/patients.service';

@Injectable({ providedIn: 'root' })
export class EmailValidatorService {
  constructor(
    private http: HttpClient,
    private patientsService: PatientsService
  ) {}

  checkEmail(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const parent = control.parent;
      if (!parent) {
        return of(null);
      }

      const name = parent.get('name')?.value;
      const lastName = parent.get('lastName')?.value;
      const email = control.value;
      if (!name || !lastName || !email) {
        return of(null);
      }
      return of(null);
      // const params = {
      //   email,
      //   name,
      //   lastName,
      // };
      // return this.checkEmailExists(params);
    };
  }

  checkEmailExists(params: {
    email: string;
    name: string;
    lastName: string;
  }): Observable<ValidationErrors | null> {
    return this.patientsService.getPatientByNameAndBirthDate(params).pipe(
      map((res) => {
        if (res) {
          return { emailInvalid: true };
        }
        return null;
      }),
      catchError(() => of({ emailInvalid: true }))
    );
  }
}
